import { Fragment, useContext } from "react";
import { LanguageContext } from "../../../../context/LanguageContext";
import { AppPagination } from "../../../../Libraries";
import TransactionItemList from "./TransactionItemList";
import TableHeader from "./TableHeader";
import { FilterNonIdeal } from "../../../common";
import { Box } from "@mui/material";
import { analytics, triggerLogEvent } from "../../../../config/firebase";

const Transactions = ({
  setPage,
  list = [],
  fetchTransactionList,
  setFilter,
  filters,
  isLoading,
  hasNext,
  debounceSearchName,
  initialFilters,
  isAppliedFilter,
  search,
  handleSetFilter,
  onClearSearch,
}) => {
  const [I18n] = useContext(LanguageContext);

  const handleClearFilter = () => {
    triggerLogEvent(analytics, "w_transactions_filter_removed");
    onClearSearch?.();
    handleSetFilter(initialFilters);
  };

  const searchTrimmed = (search || "").trim();

  return (
    <Fragment>
      <TableHeader
        handleSort={(e) =>
          setFilter({ sort: filters.sort === "Oldest" ? "Newest" : "Oldest" })
        }
        filters={filters}
      />
      {list.length > 0 ? (
        <Box
          className="transactionItemListWrapper generic-scrollbar"
          id="scrollableDiv"
        >
          <AppPagination
            data={{
              handleNext: (e) => {
                setPage((page) => {
                  if (hasNext) {
                    fetchTransactionList({
                      page: page + 1,
                      search: debounceSearchName || "",
                      filter: filters,
                    });
                    return page + 1;
                  }
                  return page;
                });
              },
              pageLoad: isLoading,
              count: hasNext,
              list: list,
              scrollableTarget: "scrollableDiv",
            }}
          >
            {list.map((item) => (
              <TransactionItemList item={item} key={item?.id} />
            ))}
          </AppPagination>
        </Box>
      ) : searchTrimmed && !isAppliedFilter ? (
        <FilterNonIdeal
          title={
            <>
              {I18n.we_could_not_find_match}
              <b>&apos;{searchTrimmed}&apos;</b>
            </>
          }
          subTitle={I18n.try_adjusting_filters}
        />
      ) : !isLoading ? (
        <Box className="h-100">
          {isAppliedFilter ? (
            <FilterNonIdeal
              title={I18n.no_transactions_matching_those_filters}
              subTitle={I18n.try_adjusting_filters}
              subTitleTextOnClick={handleClearFilter}
              subTitleText={I18n.reset_small}
            />
          ) : (
            <FilterNonIdeal
              title={I18n.no_transactions_found}
              subTitle={I18n.Youll_see_your_all}
            />
          )}
        </Box>
      ) : null}
    </Fragment>
  );
};

export default Transactions;
